import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { toast, ToastContainer } from "react-toastify";
import axios from "axios";
import "react-toastify/dist/ReactToastify.css";
import { IconUser } from '@tabler/icons-react';
import { GetCountries, GetState } from "react-country-state-city";
import "react-country-state-city/dist/react-country-state-city.css";
import { useNavigate } from "react-router-dom";
import Select from 'react-select';

export default function AddStudent() {
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    watch,
    setValue,
  } = useForm({
    defaultValues: {
      selectedCourse: [],
      selectedBatch: []
    }
  });

  const [courses, setCourses] = useState([]);
  const [batches, setBatches] = useState([]);
  const [profilePhotoPreview, setProfilePhotoPreview] = useState(null);
  const [profilePhotoFile, setProfilePhotoFile] = useState(null);
  const [studentCode, setStudentCode] = useState('');
  const [selectedCourses, setSelectedCourses] = useState([]);
  const [selectedBatches, setSelectedBatches] = useState([]);
  const token = localStorage.getItem("accessToken");

  const [countryId, setCountryId] = useState(null);
  const [stateId, setStateId] = useState(null);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const statusOptions = ["Active", "In-Active"];
  const standardOptions = ["8th", "9th", "SSLC", "Plus One", "Plus Two", "Degree", "Diploma", "PG", "Others"];

  useEffect(() => {
    const fetchStudentCode = async () => {
      try {
        const config = { headers: { Authorization: `Bearer ${token}` } };
        const response = await axios.get(
          `${process.env.REACT_APP_API}/api/course/next-student-code/`,
          config
        );
        setStudentCode(response.data?.next_student_code);
        setValue("student_code", response.data?.next_student_code);
      } catch (error) {
        console.error("Error fetching student code:", error);
        toast.error("Failed to fetch student code");
      }
    };

    if (token) fetchStudentCode();
  }, [token, setValue]);

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API}/api/course/combined-courses/`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        console.log("Courses API response:", response.data); // Debug API response
        setCourses(Array.isArray(response.data) ? response.data : []);
      } catch (error) {
        toast.error("Failed to fetch courses");
        console.error("Error fetching courses:", error);
        setCourses([]);
      }
    };

    if (token) fetchCourses();

    GetCountries()
      .then((result) => {
        setCountries(result);
        const india = result.find((country) => country.name === "India");
        if (india) {
          setCountryId(india.id);
          setValue("location_country", india.name);
          return GetState(india.id);
        }
        return null;
      })
      .then((stateResult) => {
        if (stateResult) {
          setStates(stateResult);
          const kerala = stateResult.find((state) => state.name === "Kerala");
          if (kerala) {
            setStateId(kerala.id);
            setValue("location_state", kerala.name);
          }
        }
      })
      .catch((error) => {
        console.error("Error fetching location data:", error);
      });
  }, [token, setValue]);

  const contactNumber = watch("contact");
  const parentPhoneNumber = watch("parentPhone");

  useEffect(() => {
    const fetchBatchesByCourse = async () => {
      try {
        let url = `${process.env.REACT_APP_API}/api/course/batches/`;
        if (selectedCourses.length > 0) {
          const courseIds = selectedCourses.map(course => course.value).join(',');
          url += `?course_id=${courseIds}`;
          
          const response = await axios.get(url, {
            headers: { Authorization: `Bearer ${token}` },
          });
          
          console.log("Batches API response:", response.data); // Debug batches response
          setBatches(response.data);
          
          const batchOptions = response.data.map(batch => ({
            value: batch.id,
            label: `${batch.name} (${batch.start_time} - ${batch.end_time})`,
            isDisabled: true
          }));
          
          setSelectedBatches(batchOptions);
          setValue("selectedBatch", batchOptions.map(option => option.value));
        } else {
          setBatches([]);
          setSelectedBatches([]);
          setValue("selectedBatch", []);
        }
      } catch (error) {
        console.error("Error fetching batches:", error);
        toast.error("Failed to fetch batches");
        setBatches([]);
        setSelectedBatches([]);
        setValue("selectedBatch", []);
      }
    };

    if (token) fetchBatchesByCourse();
  }, [token, selectedCourses, setValue]);

  useEffect(() => {
    if (contactNumber) setValue("whatsapp", contactNumber);
  }, [contactNumber, setValue]);

  useEffect(() => {
    if (parentPhoneNumber) setValue("parentWhatsapp", parentPhoneNumber);
  }, [parentPhoneNumber, setValue]);

  const handleCountryChange = (e) => {
    const selectedCountryId = parseInt(e.target.value);
    setCountryId(selectedCountryId);
    setStateId(null);
    const country = countries.find(c => c.id === selectedCountryId);
    if (country) setValue("location_country", country.name);
    setValue("location_state", "");
    setValue("location_city", "");

    if (selectedCountryId) {
      GetState(selectedCountryId)
        .then((result) => setStates(result))
        .catch((error) => {
          console.error("Error fetching states:", error);
          setStates([]);
        });
    } else {
      setStates([]);
    }
  };

  const handleStateChange = (e) => {
    const selectedStateId = parseInt(e.target.value);
    setStateId(selectedStateId);
    const state = states.find(s => s.id === selectedStateId);
    if (state) setValue("location_state", state.name);
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setProfilePhotoFile(file);
      const reader = new FileReader();
      reader.onloadend = () => setProfilePhotoPreview(reader.result);
      reader.readAsDataURL(file);
    } else {
      setProfilePhotoFile(null);
      setProfilePhotoPreview(null);
    }
  };

  const handleCourseChange = (selectedOptions) => {
    console.log("Selected course options:", selectedOptions); // Debug selected options
    const validOptions = Array.isArray(selectedOptions) ? selectedOptions.filter(option => option && option.value) : [];
    setSelectedCourses(validOptions);
    setValue("selectedCourse", validOptions.map(option => option.value), {
      shouldValidate: true
    });
  };

  const onSubmit = async (data) => {
    try {
      if (!token) {
        toast.error("Unauthorized: Access token missing");
        return;
      }

      if (!data.selectedCourse.length) {
        toast.error("Please select at least one course");
        return;
      }

      if (!data.selectedBatch.length) {
        toast.error("Please select at least one batch");
        return;
      }

      const formData = new FormData();
      formData.append("full_name", data.fullName);
      formData.append("student_code", data.student_code);
      formData.append("email", data.email);
      formData.append("contact_number", data.contact);
      formData.append("whatsapp_number", data.whatsapp);
      formData.append("aadhar_number", data.aadhar);
      formData.append("location_city", data.location_city);
      formData.append("location_state", data.location_state);
      formData.append("location_country", data.location_country);
      formData.append("standard", data.standard);
      formData.append("school", data.school);
      formData.append("medium", data.medium);
      formData.append("parent_name", data.parentName);
      formData.append("parent_relation", data.parentRelation);
      formData.append("parent_phone_no", data.parentPhone);
      formData.append("parent_whatsapp_no", data.parentWhatsapp);
      data.selectedCourse.forEach(courseId => {
        formData.append("selected_course_id", courseId);
      });
      data.selectedBatch.forEach(batchId => {
        formData.append("selected_batch_id", batchId);
      });
      formData.append("status", data.status === "Active" ? true : false);
      if (profilePhotoFile) formData.append("profile_photo", profilePhotoFile);

      const response = await axios.post(
        `${process.env.REACT_APP_API}/api/course/students/`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      toast.success("Student added successfully!");
      navigate('/user/listing');
      reset();
      setProfilePhotoPreview(null);
      setProfilePhotoFile(null);
      setSelectedCourses([]);
      setSelectedBatches([]);
    } catch (error) {
      console.error("Submission error:", error);
      if (error.response?.data?.aadhar_number) {
        toast.error("A student with this Aadhar number already exists.");
      } else {
        toast.error(error.response?.data?.message || "Failed to add student");
      }
    }
  };

  const courseOptions = courses
    .filter(course => course && course.id)
    .map(course => ({
      value: course.id,
      label: course.course_name || course.name || course.title || `Course ${course.id}`
    }));

  return (
    <div className="container py-4 px-5">
      <ToastContainer position="top-right" autoClose={3000} />
      <h2 className="mb-4">Add Student</h2>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="row g-3">
          <div className="col-12">
            <label className="form-label small mb-0">Profile Photo</label>
            <div className="d-flex align-items-center">
              <div
                className="rounded-circle overflow-hidden"
                style={{ width: "100px", height: "100px", position: "relative", border: "1px solid #ddd" }}
              >
                {profilePhotoPreview ? (
                  <img
                    src={profilePhotoPreview}
                    alt="Profile Preview"
                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                  />
                ) : (
                  <div
                    style={{
                      width: "100%",
                      height: "100%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      backgroundColor: "#f0f0f0",
                    }}
                  >
                    <IconUser size={40} color="#666" />
                  </div>
                )}
              </div>
              <input
                type="file"
                id="profilePhoto"
                style={{ display: "none" }}
                onChange={handleFileChange}
                accept="image/*"
              />
              <button
                type="button"
                className="btn btn-secondary ms-3"
                onClick={() => document.getElementById("profilePhoto").click()}
              >
                Select File
              </button>
            </div>
          </div>

          <div className="col-md-4 col-12">
            <label className="form-label small mb-0">Full Name</label>
            <input
              type="text"
              className="form-control border-2"
              style={{ backgroundColor: '#00000010' }}
              {...register("fullName", { required: "Full Name is required" })}
            />
            {errors.fullName && <span className="text-danger">{errors.fullName.message}</span>}
          </div>

          <div className="col-md-4 col-12">
            <label className="form-label small mb-0">Student Code</label>
            <input
              type="text"
              value={studentCode}
              disabled
              className="form-control border-2"
              style={{ backgroundColor: '#00000010' }}
              {...register("student_code", { required: "Student Code is required" })}
            />
            {errors.student_code && <span className="text-danger">{errors.student_code.message}</span>}
          </div>

          <div className="col-md-4 col-12">
            <label className="form-label small mb-0">Email Address</label>
            <input
              type="email"
              className="form-control border-2"
              style={{ backgroundColor: '#00000010' }}
              {...register("email")}
            />
            {errors.email && <span className="text-danger">{errors.email.message}</span>}
          </div>

          <div className="col-md-4 col-12">
            <label className="form-label small mb-0">Contact Number</label>
            <input
              type="number"
              className="form-control border-2"
              style={{ backgroundColor: '#00000010' }}
              {...register("contact", { required: "Contact Number is required" })}
            />
            {errors.contact && <span className="text-danger">{errors.contact.message}</span>}
          </div>

          <div className="col-md-4 col-12">
            <label className="form-label small mb-0">WhatsApp Number</label>
            <input
              type="number"
              className="form-control border-2"
              style={{ backgroundColor: '#00000010' }}
              {...register("whatsapp", { required: "WhatsApp Number is required" })}
            />
            {errors.whatsapp && <span className="text-danger">{errors.whatsapp.message}</span>}
          </div>

          <div className="col-md-4 col-12">
            <label className="form-label small mb-0">Aadhar Number</label>
            <input
              type="text"
              className="form-control border-2"
              style={{ backgroundColor: '#00000010' }}
              {...register("aadhar", {
                pattern: {
                  value: /^[0-9]{12}$/,
                  message: "Aadhar must be 12 digits"
                }
              })}
            />
            {errors.aadhar && <span className="text-danger">{errors.aadhar.message}</span>}
          </div>

          <div className="col-md-4 col-12">
            <label className="form-label small mb-0">Country</label>
            <select
              className="form-select border-2"
              style={{ backgroundColor: '#00000010' }}
              onChange={handleCountryChange}
              value={countryId || ""}
            >
              <option value="">Select Country</option>
              {countries.map((country) => (
                <option key={country.id} value={country.id}>
                  {country.name}
                </option>
              ))}
            </select>
            <input
              type="hidden"
              {...register("location_country", { required: "Country is required" })}
            />
            {errors.location_country && <span className="text-danger">{errors.location_country.message}</span>}
          </div>

          <div className="col-md-4 col-12">
            <label className="form-label small mb-0">State</label>
            <select
              className="form-select border-2"
              style={{ backgroundColor: '#00000010' }}
              onChange={handleStateChange}
              value={stateId || ""}
              disabled={!countryId}
            >
              <option value="">Select State</option>
              {states.map((state) => (
                <option key={state.id} value={state.id}>
                  {state.name}
                </option>
              ))}
            </select>
            <input
              type="hidden"
              {...register("location_state", { required: "State is required" })}
            />
            {errors.location_state && <span className="text-danger">{errors.location_state.message}</span>}
          </div>

          <div className="col-md-4 col-12">
            <label className="form-label small mb-0">City</label>
            <input
              type="text"
              className="form-control border-2"
              style={{ backgroundColor: '#00000010' }}
              {...register("location_city", { required: "City is required" })}
            />
            {errors.location_city && <span className="text-danger">{errors.location_city.message}</span>}
          </div>

          <div className="col-md-4 col-12">
            <label className="form-label small mb-0">Standard</label>
            <select
              className="form-select border-2"
              style={{ backgroundColor: '#00000010' }}
              {...register("standard", { required: "Standard is required" })}
            >
              <option value="">Select Standard</option>
              {standardOptions.map((option, index) => (
                <option key={index} value={option}>
                  {option}
                </option>
              ))}
            </select>
            {errors.standard && <span className="text-danger">{errors.standard.message}</span>}
          </div>

          <div className="col-md-4 col-12">
            <label className="form-label small mb-0">School</label>
            <input
              type="text"
              className="form-control border-2"
              style={{ backgroundColor: '#00000010' }}
              {...register("school", { required: "School is required" })}
            />
            {errors.school && <span className="text-danger">{errors.school.message}</span>}
          </div>

          <div className="col-md-4 col-12">
            <label className="form-label small mb-0">Medium</label>
            <select
              className="form-select border-2"
              style={{ backgroundColor: '#00000010' }}
              {...register("medium", { required: "Medium is required" })}
            >
              <option value="">Select Medium</option>
              <option value="English">English</option>
              <option value="Malayalam">Malayalam</option>
            </select>
            {errors.medium && <span className="text-danger">{errors.medium.message}</span>}
          </div>

          <div className="col-md-4 col-12">
            <label className="form-label small mb-0">Parent Name</label>
            <input
              type="text"
              className="form-control border-2"
              style={{ backgroundColor: '#00000010' }}
              {...register("parentName", { required: "Parent Name is required" })}
            />
            {errors.parentName && <span className="text-danger">{errors.parentName.message}</span>}
          </div>

          <div className="col-md-4 col-12">
            <label className="form-label small mb-0">Parent Relation</label>
            <input
              type="text"
              className="form-control border-2"
              style={{ backgroundColor: '#00000010' }}
              {...register("parentRelation", { required: "Parent Relation is required" })}
            />
            {errors.parentRelation && <span className="text-danger">{errors.parentRelation.message}</span>}
          </div>

          <div className="col-md-4 col-12">
            <label className="form-label small mb-0">Parent Phone No</label>
            <input
              type="number"
              className="form-control border-2"
              style={{ backgroundColor: '#00000010' }}
              {...register("parentPhone", { required: "Parent Phone is required" })}
            />
            {errors.parentPhone && <span className="text-danger">{errors.parentPhone.message}</span>}
          </div>

          <div className="col-md-4 col-12">
            <label className="form-label small mb-0">Parent WhatsApp No</label>
            <input
              type="number"
              className="form-control border-2"
              style={{ backgroundColor: '#00000010' }}
              {...register("parentWhatsapp", { required: "Parent WhatsApp is required" })}
            />
            {errors.parentWhatsapp && <span className="text-danger">{errors.parentWhatsapp.message}</span>}
          </div>

          <div className="col-md-4 col-12">
            <label className="form-label small mb-0">Status</label>
            <select
              className="form-select border-2"
              style={{ backgroundColor: '#00000010' }}
              {...register("status", { required: "Status is required" })}
            >
              <option value="">Select Status</option>
              {statusOptions.map((option, index) => (
                <option key={index} value={option}>
                  {option}
                </option>
              ))}
            </select>
            {errors.status && <span className="text-danger">{errors.status.message}</span>}
          </div>

          <div className="col-md-4 col-12">
            <label className="form-label mb-0 small">Courses</label>
            <Select
              isMulti
              options={courseOptions}
              value={selectedCourses}
              onChange={handleCourseChange}
              className="basic-multi-select"
              classNamePrefix="select"
              placeholder="Select Courses"
              styles={{
                control: (base) => ({
                  ...base,
                  backgroundColor: '#00000010',
                  borderColor: '#ced4da'
                })
              }}
            />
            {errors.selectedCourse && <span className="text-danger">{errors.selectedCourse.message}</span>}
            <input
              type="hidden"
              {...register("selectedCourse", {
                validate: value => value.length > 0 || "At least one course is required"
              })}
            />
          </div>

          <div className="col-md-4 col-12">
            <label className="form-label mb-0 small">Batches</label>
            <Select
              isMulti
              options={selectedBatches}
              value={selectedBatches}
              isDisabled={true}
              className="basic-multi-select"
              classNamePrefix="select"
              placeholder="Select Batches"
              styles={{
                control: (base) => ({
                  ...base,
                  backgroundColor: '#00000010',
                  borderColor: '#ced4da'
                })
              }}
            />
            {errors.selectedBatch && <span className="text-danger">{errors.selectedBatch.message}</span>}
            <input
              type="hidden"
              {...register("selectedBatch", {
                validate: value => value.length > 0 || "At least one batch is required"
              })}
            />
          </div>

          <div className="mt-4 w-100 d-flex justify-content-end">
            <button type="submit" className="btn btn-primary">
              Submit
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}